import { SlideComponentHkcsEnQ2 } from '@/types/slide';
import { SlideComponentCreator } from './factory';

export class SlideComponentHkcsEnQ2Creator extends SlideComponentCreator {
    public create(id: string): SlideComponentHkcsEnQ2 {
        return {
            id: id,
            type: 'hkcsEnQ2',
            pos: {
                x: 0,
                y: 0,
            },
            size: {
                width: 200,
                height: 200,
            },
            content: {
                phrase: '',
                sampleSentence: '',
                image: '',
                imageURL: '',
                flip: 1,
                audio: [],
            },
        };
    }
}
